import React, { Fragment, useState } from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  NavbarText,
  Button
} from 'reactstrap';
import logo from '../../assets/images/logo.png';
import { PROFILE_PATH, SIGNIN_PATH, AGENCY_PROFILE_PATH } from '../../utils/AppRoutes';
import { Link, useHistory } from 'react-router-dom';

import defaultAvatar from '../../assets/images/defaultImages/defaultAvatar.png';
import { logout } from '../../utils/functions/CoreFunctions';
import { getConfirm, getCurrentUserName, getCurrentProfile, getCurrentRole } from '../../utils/functions/CustomFunctions';
import Swal from 'sweetalert2';

const Header = () => {

    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);

    const history = useHistory();

    const logoutClick = () => {
        Swal.fire(
           getConfirm('warning', 'Are you sure you want to sign out?')
        )
        .then(result => 
        {
            if (result.value) {
                logout(history);
            }
        });  
    }

    return (       
      <Navbar fixed='top' color='light' light className='navbar-bg' expand='md'>
        <NavbarBrand href='/'> <img src={logo}  /></NavbarBrand>
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className='m-auto item-center' navbar>
           {/* <Button href='/upload-document' className='f-r ml-5' outline color='primary'><i className='fas fa-file-medical'></i>Create License</Button> */}
          </Nav>
          <NavbarText className='item-center'> 
            <UncontrolledDropdown nav inNavbar className='nav-dropdown'>
              <DropdownToggle nav caret>
              <img className='UserImg' src={getCurrentProfile() || defaultAvatar} />
              {/* <span>Natosha Jacobs</span> */}
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem>
                <img className='dropdown-userImg' src={getCurrentProfile() || defaultAvatar} />
                <h6 className='text-center'>{ getCurrentUserName() }</h6>
                <p className='text-center'>{ getCurrentRole() }</p>
                </DropdownItem>
                <Link to={PROFILE_PATH}>
                <DropdownItem style={{cursor:'pointer'}}>
                My Profile 
                </DropdownItem>
                </Link>
                <Link to={AGENCY_PROFILE_PATH}>
                <DropdownItem style={{cursor:'pointer'}}>
                Agency Profile 
                </DropdownItem>
                </Link>
                <DropdownItem />
                <DropdownItem onClick={logoutClick} style={{cursor:'pointer'}}>
                    Sign Out
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </NavbarText>
        </Collapse>
      </Navbar>          
    )
}

export default Header;